



















































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { StudentInfo } from '../../types/payment';

@Component
export default class UserInfo extends Vue {
  @Prop({ default: 'primary' }) subjectColor!: string;
  @Prop() onSubmitted!: (info: StudentInfo) => {};
  private firstName = '';
  private lastName = '';
  private nickName = '';
  private firstNameEn = '';
  private lastNameEn = '';
  private nickNameEn = '';
  private email = '';
  private lineId = '';
  private parentLineId = '';
  private school = '';
  private grade = '';
  private interestedLesson = '';
  private recommendedById = '';
  private saleMan = '';
  private gradeList = [
    'เตรียมอนุบาล',
    'อ.1',
    'อ.2',
    'อ.3',
    'ป.1',
    'ป.2',
    'ป.3',
    'ป.4',
    'ป.5',
    'ป.6',
    'ม.1',
    'ม.2',
    'ม.3',
    'ม.4',
    'ม.5',
    'ม.6',
  ];

  private get canSubmit(): boolean {
    return (
      this.firstName !== '' &&
      this.lastName !== '' &&
      this.nickName !== '' &&
      this.email !== '' &&
      this.school !== '' &&
      this.grade !== '' &&
      this.lineId !== '' &&
      this.parentLineId !== ''
    );
  }

  private submit() {
    this.onSubmitted({
      firstName: this.firstName,
      lastName: this.lastName,
      nickName: this.nickName,
      firstNameEn: this.firstNameEn,
      lastNameEn: this.lastNameEn,
      nickNameEn: this.nickNameEn,
      email: this.email,
      lineId: this.lineId,
      parentLineId: this.parentLineId,
      school: this.school,
      grade: this.grade,
      interestedLesson: this.interestedLesson,
      recommendedById: this.recommendedById,
      saleMan: this.saleMan,
    });
  }
}
